/* shah */
import React from 'react'

const FontIcon = () => {
    return (
        <svg id="SmallBoxSVG-font" fill="currentColor" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1075 1024" className="icon" style={{ display: "inline-flex" }}>
            <path xmlns="http://www.w3.org/2000/svg"
                d="M647.772 817.874H518.344l-50.905-139.781H218.943l-50.907 139.781H42.063l234.69-611.749h138.053l232.966 611.749zM427.749 569.38l-84.558-231.242-84.558 231.242h169.116zm187.562-261.482c-29.901 0-54.139 24.239-54.139 54.138s24.238 54.138 54.139 54.138h396.616c29.896 0 54.134-24.239 54.134-54.138s-24.238-54.138-54.134-54.138H615.311zm73.319 175.909c-29.901 0-54.139 24.239-54.139 54.136 0 29.901 24.238 54.139 54.139 54.139h323.297c29.896 0 54.134-24.238 54.134-54.139 0-29.898-24.238-54.136-54.134-54.136H688.63zm67.01 175.91c-29.896 0-54.134 24.238-54.134 54.139 0 29.896 24.238 54.134 54.134 54.134h256.287c29.896 0 54.134-24.238 54.134-54.134 0-29.901-24.238-54.139-54.134-54.139H755.64z"></path>
        </svg>
    )
}

export default FontIcon